import React, { ReactNode } from 'react';
import { Box, Flex, Heading, Image, Text, useMediaQuery } from '@chakra-ui/react';
import logo from '../../assets/images/logo_black.png';
import background from '../../assets/images/fundo-login.png';

interface AuthLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthLayout = ({ title, description, children, footer }: AuthLayoutProps) => {
  const [isSmallerThanMd] = useMediaQuery('(max-width: 767px)');

  return (
    <Flex h="full" minH="100vh" bg="surface.base" p={{ base: '0', md: '10px' }}>
      <Flex w="full" direction="column" justify="space-between" px={{ base: '24px', md: '48px' }}>
        <Image
          src={logo}
          h="68px"
          w="auto"
          alignSelf="center"
          objectFit="contain"
          mt="32px"
          alt="Jornada Ser"
        />

        <Box w="full" maxW="360px" mx="auto">
          <Heading
            as="h1"
            fontFamily="display"
            fontSize="24px"
            lineHeight="30px"
            fontWeight={500}
            color="content.strong"
            textAlign="center"
          >
            {title}
          </Heading>
          {description && (
            <Text
              mt="4px"
              fontSize="13px"
              lineHeight="20px"
              color="content.body"
              textAlign="center"
            >
              {description}
            </Text>
          )}
          <Box mt="32px">{children}</Box>
        </Box>

        <Text fontSize="12px" color="content.faint" textAlign="center" mb="24px">
          {footer ?? 'Acesso exclusivo ao painel administrativo Jornada Ser.'}
        </Text>
      </Flex>

      {!isSmallerThanMd && (
        <Box
          w="full"
          maxW="50%"
          borderRadius="xl"
          backgroundImage={background}
          backgroundSize="cover"
          backgroundPosition="center"
          position="relative"
          overflow="hidden"
        >
          <Box
            position="absolute"
            inset={0}
            bgGradient="linear(to-t, rgba(18, 63, 98, 0.85), rgba(18, 63, 98, 0.15))"
          />
          <Box position="absolute" bottom="40px" left="40px" right="40px">
            <Heading
              as="h2"
              fontFamily="display"
              fontSize="24px"
              lineHeight="30px"
              fontWeight={500}
              color="white"
            >
              Experiências para fortalecer a unicidade do indivíduo.
            </Heading>
            <Text mt="12px" fontSize="13px" lineHeight="20px" color="whiteAlpha.800">
              Gerencie instituições, turmas, conteúdos e pessoas em um só lugar.
            </Text>
          </Box>
        </Box>
      )}
    </Flex>
  );
};
